
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-disability"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-disability"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>


    <div class="edit-disability-body">
      <div class="disability-label-info">
        <label class="disability-label">
          Do you consider yourself to be eligible for any of the
          following football pathways?

          <a
            class="d-icon"
            role="link"
            aria-label="disbaility info details"
            tabindex="0"
            (keypress)="dialogData.showDisabilityTitleInfo = true"
            (click)="dialogData.showDisabilityTitleInfo = true"
          ></a>
        </label>
        @if (dialogData.showDisabilityTitleInfo) {
          <div
            tabindex="-1"
            aria-label="disability title info tooltip"
            class="disability-title-info-popup"
            role="tooltip"
            >
            <p tabindex="0">
              Under the Equality Act 2010, disability is defined as a
              physical or mental impairment that has a substantial and
              long term adverse effect on the ability to carry out normal
              day to day activities. Substantial means more than minor or
              trivial. Impairment covers, for example, long term medical
              conditions such as asthma and diabetes, and fluctuating or
              progressive conditions such as rheumatoid arthritis or motor
              neurone diseases. A mental impairment includes mental health
              conditions(such as bipolar disorder or depression), learning
              difficulties (such as dyslexia) and learning disabilities
              (such as autism and Down's syndrome). Some peope including
              those with cancer, multipe sclerosis and HIV/AIDS are
              automatically protected as disabled people by the Act.<br /><br />
            </p>
            <button
              role="button"
              tabindex="0"
              aria-label="Got it- Close disbaility title info details"
              class="dbs-button"
          (click)="
          dialogData.showDisabilityTitleInfo = false; dialogData.closeTooltip($event)
          "
          (keypress)="
          dialogData.closeTooltipTab($event); dialogData.showDisabilityTitleInfo = false
          "
              >
              GOT IT
            </button>
          </div>
        }
      </div>
      <form
        [formGroup]="dialogData.disabilityForm"
        (ngSubmit)="dialogData.saveDisabilityDetails()"
        >
        <div class="disability-scroll">
          @for (disabilityItem of dialogData.disability; track disabilityItem; let i = $index) {
            <div
              formArrayName="disabilities"
              >
              <div class="disability-option">
                <mat-checkbox
                  (change)="dialogData.checkedEvent($event, dialogData.disabilityItem.id)"
                  [formControlName]="i"
                  >
                  <span class="disability-text">{{
                    disabilityItem.disabilityTypeName
                  }}</span>
                </mat-checkbox>
                @if (disabilityItem.description !== null) {
                  <span
                    class="disability-info-icon icon-info"
                    tabIndex="0"
                    (keypress)="dialogData.getDisabilityInfo(i)"
                    (click)="dialogData.getDisabilityInfo(i)"
                  ></span>
                }
                @if (dialogData.showDisabilityInfo && dialogData.disabilityPopupIndex === i) {
                  <div
                    tabindex="-1"
                    aria-label="disability info tooltip"
                    class="disability-info-popup"
                    role="tooltip"
                    >
                    <p tabindex="0">
                      {{ dialogData.disabilityInfo }}
                      @if (dialogData.disabilityLink) {
                        <a
                          href="#"
                          (click)="dialogData.openDisabilityInfo($event)"
                          >here</a
                          >
                          }.<br /><br />
                        </p>
                        <button
                          role="button"
                          tabindex="0"
                          aria-label="Got it- Close disbaility title info details"
                          class="dbs-button"
                (click)="
                dialogData.showDisabilityInfo = false; dialogData.closeTooltip($event)
                "
                (keypress)="
                dialogData.closeTooltipTab($event); dialogData.showDisabilityInfo = false
                "
                          >
                          GOT IT
                        </button>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="btn-container disability-button">
              @if (dialogData.showErrorMessage && !dialogData.disabilityForm.valid) {
                <div
                  class="form-error"
                  >
                  Please select at least one disability
                </div>
              }
              <button
                tabindex="0"
                role="button"
                aria-label="save"
                class="send-button"
                (click)="dialogData.disabilitySave = true"
                >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="blank-space">

      </div>


